import { BaseController } from '../../common/base/controller';
import {
  transferringListStateName,
  receivingListStateName,
} from '../tickets/ticketOverview/ticketOverview.state';
import { receivingCreateRequestStateName } from '../tickets/create/receiving/createRequest/createRequest.state';
import { uploadWarrantStateName } from '../tickets/create/transferring/uploadWarrant/uploadWarrant.state';
import { ProductType } from '../ticket/ticket.constants';

export class HomeController extends BaseController {
  constructor(
    controllerService,
    $element,
    featureFlagService,
    FeatureFlagNames,
  ) {
    'ngInject';
    super({ controllerService, featureFlagService, FeatureFlagNames });

    $element.addClass('home-component');
  }

  $onInit() {
    this.heroImage = this.config.ui.home.heroImage;
  }

  get showNachlassBtn() {
    return this.isFeatureActive(this.FeatureFlagNames.FF_NACHLASS);
  }

  get showOldBankActions() {
    return this.config.ui.navbar.tabs.transferring;
  }

  goTicketsTransferring() {
    this.go(transferringListStateName);
  }

  goCreateTicketTransferring() {
    this.go(uploadWarrantStateName);
  }

  goTicketsReceiving() {
    if (
      this.isFeatureActive(this.FeatureFlagNames.FF_SPLIT_BY_SWITCH_PRODUCTS)
    ) {
      return this.go(receivingListStateName, { product: ProductType.KWH });
    }
    return this.go(receivingListStateName);
  }

  goCreateTicketReceiving() {
    this.go(receivingCreateRequestStateName);
  }

  goCreateNachlassTicket() {
    this.go(receivingCreateRequestStateName, { nachlass: true });
  }
}
